import React from 'react';

import styled from 'styled-components';
import { UserContext } from '../UserProvider';
import { DataContext } from '../DataProvider';

import AuthDialog from '../AuthDialog';
import ResetPasswordDialog from '../ResetPassword';

function NavBar() {
  const { isAuthenticated, handleLogout } = React.useContext(UserContext);
  const {
    selectedCourse,
    setSelectedCourse,
    setLessons,
    setSelectedCourseTitle,
  } = React.useContext(DataContext);

  const returnHome = () => {
    setSelectedCourse(null);
    setSelectedCourseTitle(null);
    setLessons([]);
  };

  const LoginLogout = isAuthenticated ? (
    <NavItem selected={selectedCourse} onClick={handleLogout}>
      Logout
    </NavItem>
  ) : (
    <NavItem selected={selectedCourse}>
      <AuthDialog />
    </NavItem>
  );

  const volumeOnSVG = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-volume-2'
    >
      <polygon points='11 5 6 9 2 9 2 15 6 15 11 19 11 5' />
      <path d='M15.54 8.46a5 5 0 0 1 0 7.07' />
      <path d='M19.07 4.93a10 10 0 0 1 0 14.14' />
    </svg>
  );

  return (
    <FlexWrapper selected={selectedCourse}>
      <NavItem selected={selectedCourse}>{volumeOnSVG}</NavItem>
      {LoginLogout}
      <NavItem>
        <ResetPasswordDialog />
      </NavItem>
      <NavItem selected={selectedCourse} onClick={returnHome}>
        Home
      </NavItem>
      {/* {AddProject} */}
      {/* <ProjectDropdown selectFollowUp={handleSelectValue} /> */}
    </FlexWrapper>
  );
}

export default NavBar;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 10px;
  background-color: ${({ selected }) => (selected ? 'black' : 'white')};
`;

const NavItem = styled.button`
  color: ${({ selected }) => (selected ? 'white' : 'black')};
  border-left: 1px solid var(--number-box-border-color);
  border-bottom: 1px solid var(--number-box-border-color);
  border-right: 1px solid var(--number-box-border-color);
  &:hover {
    color: ${({ selected }) => (selected ? 'red' : 'red')};
  }
  display: flex;
  padding: 2px 6px;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  a {
    text-decoration: none;
    color: inherit;
  }
`;
